export default "__VITE_PUBLIC_ASSET__76f0395e__"